import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { AppTheme } from '@/theme/index';
import { useAuthStore } from '@/store';
import { useSelectionStore } from '@/store/selectionStore';
import { useQueryClient } from '@tanstack/react-query';
import { MenuItem, type MenuItemVariation } from '../MenuItem';
import { axiosInstance, apiHelpers } from '@/api/core';

interface LogoutProps {
  isOpen: boolean;
  theme: AppTheme;
}

export const Logout: React.FC<LogoutProps> = ({ isOpen, theme }) => {
  const variation: MenuItemVariation = 'settings';
  const { logout } = useAuthStore();
  const { reset: resetSelection } = useSelectionStore();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  // useMutation 훅 대신 apiHelpers 직접 호출 — 로그아웃은 세션/스토어/쿼리 캐시를
  // 모두 초기화한 뒤 /login으로 이동해야 하므로 React Query 생명주기 밖에서 처리.
  const handleLogout = async () => {
    try {
      const refreshToken = sessionStorage.getItem('refresh_token');
      if (refreshToken) {
        await apiHelpers.post('auth.logout', { refresh_token: refreshToken });
      }
    } catch {
      // 서버 로그아웃 실패해도 클라이언트 로그아웃 진행
    }

    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('refresh_token');
    sessionStorage.removeItem('token_expiry');
    delete axiosInstance.defaults.headers.common.Authorization;

    logout();
    resetSelection();
    queryClient.clear();

    navigate('/login');
  };

  return (
    <MenuItem
      icon="/icons/IconLog-out.svg"
      label="Log out"
      isOpen={isOpen}
      theme={theme}
      variation={variation}
      onClick={handleLogout}
    />
  );
};
